import '../fixtures_match_list/index.css';
import { useEffect, useState } from 'react';
import useGame from '../../../utilities/hooks/game';
import { useDispatch } from 'react-redux';
import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import { useLink } from 'react-router-stack';
import LiveMatchListMWeb from './index_mWeb';
import LiveMatchListWeb from './index_Web';

const LiveMatchList = ({ list }: any) => {
  const dispatch = useDispatch();
  const navigate = useLink();
  const { gameType, fantasyMatchClick, setMyTeamList } = useGame();
  const [liveMatchList, setLiveMatchList] = useState([] as any);

  useEffect(() => {
    setLiveMatchList([...list]);
  }, []);

  const onPressMatchCard = (matchItem: any) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: true,
          joined: false,
          joinedMatch: true,
          contestId: '',
          entryFee: '',
          isTeamSwitch: false,
          tabType: 'LIVE'
        }
      })
    );

    navigate.push(getRouteObjByGame(gameType)['my_contests']);
  };

  const onPressAddSubstitute = (matchItem: any) => {
    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          completed: false,
          isEditSubstitute: true,
          tabType: 'LIVE',
          myContestJoinedTeams: []
        }
      })
    );
    dispatch(setMyTeamList([]));
    navigate.push('/my_teams_substitute');
  };

  return (
    <>
      {isSmartPhone ? (
        <LiveMatchListMWeb
          onPressMatchCard={onPressMatchCard}
          onPressAddSubstitute={onPressAddSubstitute}
          liveMatchList={liveMatchList}
        />
      ) : (
        <LiveMatchListWeb
          onPressMatchCard={onPressMatchCard}
          onPressAddSubstitute={onPressAddSubstitute}
          liveMatchList={liveMatchList}
        />
      )}
    </>
  );
};

export default LiveMatchList;
